import { WarningTwoTone } from "@ant-design/icons";
import { Col, Collapse, Form, Row, Space, Spin, Typography } from "antd";
import React, { useEffect, useMemo } from "react";
import PdfViewer from "./PdfViewer";
import { useDispatch, useSelector } from "react-redux";
import ReportPanelBottomBar from "./ReportPanelBottomBar";
import openNotificationOperationResult from "./openNotificationOperationResult";
import {
  clearOperationResult,
  resetReportState,
} from "../../store/report/reportActions";
import {
  clearListCompactAction,
  listAgenciesCompactAction,
} from "../../store/agency/agencyActions";

const { Text } = Typography;

const ReportPanel = ({
  isDirty,
  isSubmitted,
  onSubmit,
  buttons,
  taskId,
  listAgenciesEndpoint = "ListAgenciesCompact",
  children,
}) => {
  //
  const dispatch = useDispatch();

  //
  const isViewerVisible = useSelector((state) => state.report.isViewerVisible);
  const isFetching = useSelector((state) => state.report.isFetching);
  const operationResult = useSelector((state) => state.report.operationResult);
  const brokerId = useSelector((state) => state.actor.details.data.BrokerId);

  //
  useEffect(() => {
    openNotificationOperationResult(operationResult, () =>
      dispatch(clearOperationResult())
    );
  }, [operationResult]);

  useEffect(() => {
    if (brokerId != null) {
      dispatch(
        listAgenciesCompactAction(brokerId, taskId, listAgenciesEndpoint)
      );
    }
  }, [brokerId]);

  useEffect(() => {
    dispatch(resetReportState());
    return () => {
      dispatch(clearListCompactAction());
    };
  }, []);

  //
  const header = useMemo(() => {
    const paramsDirty =
      isDirty && isViewerVisible && !isFetching && !isSubmitted;

    if (!paramsDirty) return <Text>Report Parameters</Text>;

    return (
      <Space>
        <Text>Report Parameters</Text>
        <Text type="warning">
          <WarningTwoTone twoToneColor="#faad14" /> Report shown does not match
          selected parameters. Click{" "}
          <Text type="warning" strong>
            "Preview"
          </Text>{" "}
          to refresh.
        </Text>
      </Space>
    );
  }, [isDirty, isViewerVisible, !isFetching, !isSubmitted]);

  return (
    <div>
      <Row>
        <Col span={24}>
          <Collapse
            defaultActiveKey={["1"]}
            items={[
              {
                key: "1",
                label: header,
                children: (
                  <Form size="small" autoComplete="off" onFinish={onSubmit}>
                    <Spin spinning={isFetching} indicator={<div />}>
                      {children}
                    </Spin>
                    <ReportPanelBottomBar buttons={buttons} />
                  </Form>
                ),
              },
            ]}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: 16 }}>
        <Col span={24}>
          {isViewerVisible && <PdfViewer isDirty={isDirty} />}
        </Col>
      </Row>
    </div>
  );
};

export default ReportPanel;
